import api from 'api/api'
import { toast } from 'react-toastify'

export const GET_ALL_OPERATORS = "[OPERATORS] GET ALL OPERATORS"
export const CRUD_OPERATOR = "[OPERATORS] CRUD OPERATOR"

export function getAllOperators() {
  const request = api.get(`/operador`)

  return (dispatch) =>
    request.then((response) => {
      dispatch({
        type: GET_ALL_OPERATORS,
        payload: response.data.detalles,
      })
    })
}

export function saveOperator(form) {
  const request = api.post(`/roperador`, form)
  return (dispatch) =>
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        toast.success(response.data.message)
      } else {
        toast.error(response.data.message)
      }

      dispatch({ type: CRUD_OPERATOR, payload: true })
      setTimeout(() => {
        dispatch({ type: CRUD_OPERATOR, payload: false })
      }, 50)
    })
}

export function updateOperator(form) {
  const request = api.post(`/aoperador`, form)
  return (dispatch) =>
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        toast.success(response.data.message)
      } else {
        toast.error(response.data.message)
      }

      dispatch({ type: CRUD_OPERATOR, payload: true })
      setTimeout(() => {
        dispatch({ type: CRUD_OPERATOR, payload: false })
      }, 50)
    })
}

export function deleteOperator(form) {
  const request = api.post(`/eoperador`, form)
  return (dispatch) =>
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        toast.success(response.data.message)
      } else {
        toast.error(response.data.message)
      }

      dispatch({ type: CRUD_OPERATOR, payload: true })
      setTimeout(() => {
        dispatch({ type: CRUD_OPERATOR, payload: false })
      }, 50)
    })
}

export function updateStatusByOperator(form) {
  const request = api.post(`/coperador`, form)
  return (dispatch) =>
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        toast.success(response.data.message)
      } else {
        toast.error(response.data.message)
      }

      dispatch({ type: CRUD_OPERATOR, payload: true })
      setTimeout(() => {
        dispatch({ type: CRUD_OPERATOR, payload: false })
      }, 50)
    })
}
